<div id="kt_drawer_notificationslist" class="bg-body" data-kt-drawer="true" data-kt-drawer-name="notificationslist"
     data-kt-drawer-activate="true" data-kt-drawer-overlay="true" data-kt-drawer-width="{default:'280px', 'md': '400px'}"
     data-kt-drawer-direction="end" data-kt-drawer-toggle="#kt_drawer_notificationslist_toggle"
     data-kt-drawer-close="#kt_drawer_notificationslist_close">
  <div class="card w-100 rounded-0">
    <div class="card-header pe-5">
      <div class="card-title">
        <div class="d-flex justify-content-center flex-row align-items-center me-3">
          <a class="
              fs-4
              fw-bolder
              text-gray-900
              me-1
              mb-1
              lh-1
            pe-none
            ">
        {{"notification.notification" | translate}}


          </a>
          <span class="text-primary">{{alertSub.value?.length}}</span>
        </div>
      </div>
      <div class="card-toolbar">
        <div class="btn btn-sm btn-icon btn-active-light-primary" id="kt_drawer_notificationslist_close">
          <span class="svg-icon svg-icon-2"></span>
          <span [inlineSVG]="'./assets/media/icons/duotune/arrows/arr061.svg'" class="svg-icon svg-icon-2"></span>
        </div>
      </div>
    </div>
    <div class="card-body scroll-y px-2">
      <div class=" " >
        <ng-container *ngIf="alerts$ | async as alerts ;else loadingTemplate">
          <ng-container *ngIf="alerts.length !==0 ; else nodata">
            <ng-container *ngFor="let alert of alerts" class="d-flex flex-stack py-4">
              <div class="alert alert-dismissible  border border-bottom-0  border-end-0  border-top-0   border-left-5 border-primary d-flex flex-column flex-sm-row py-0 " style="background-color: #F8F8F8">
<!--               <span data-kt-element="bullet"-->
<!--                     class="bullet bullet-vertical d-flex align-items-center min-h-80px mh-100 me-4 ms-n3 " style="background-color: #FD4A4A"></span>-->

                <!--begin::Wrapper-->
                <div class="d-flex flex-column w-100 pt-2">
                  <!--begin::Title-->
                  <span class="mb-1 ">  <!--begin::Name-->
                    <a [href]="alert?.link" target="_blank"  class="text-dark fs-base opacity-75-hover fw-bold">{{ alert.title }}</a>
                    <!--end::Name--></span>
                  <!--end::Title-->

                  <!--begin::Content-->
                  <span  class=" fs-6"  [innerHTML]="alert.body"></span>
                  <!--end::Content-->
                  <div>
                  <span class="d-flex justify-content-end fs-7 badge badge-light">{{ alert.created_at |lcmsswissDate : 'full' }}</span>
                  </div>
                </div>
                <!--end::Wrapper-->

                <!--begin::Close-->

                                <a (click)="readNotif(alert.id , alerts)" class="position-absolute position-sm-relative m-2 mt-n4 me-n12 top-0 end-0 btn btn-icon me-n20 cursor-pointer text-hover-danger">
                                    <span class="symbol-label">
                                      <span
                                        class="svg-icon svg-icon-2 svg-icon-hover-danger"
                                      >
                                        <i class=" fa-solid fa-x fa-2xl"></i>
                                      </span>
                                    </span>
                                </a>
                <!--end::Close-->
              </div>
              <!--end::Alert-->
<!--              <div class="d-flex align-items-center justify-content-between alert alert-info ">-->
<!--                <div class="d-flex align-items-center">-->

<!--                  <div class="mb-0 me-2 ">-->
<!--                    <a [href]="alert?.link" target="_blank" class="fs-8 text-gray-800  fw-bolder" [ngClass]="alert.link ? 'text-hover-primary' : 'pe-none' ">-->
<!--                      {{ alert.title }}-->
<!--                    </a>-->
<!--                    <div class="text-gray-400 fs-9" [innerHTML]="alert.body"></div>-->
<!--                  </div>-->
<!--                </div>-->

<!--                <span class="badge badge-light fs-8 badge-ou">{{ alert.created_at |lcmsswissDate : 'full' }}</span>-->
<!--                <a (click)="readNotif(alert.id , alerts)" class="symbol symbol-35px me-4 cursor-pointer text-hover-danger">-->
<!--                    <span class="symbol-label">-->
<!--                      <span-->
<!--                        class="svg-icon svg-icon-2 svg-icon-hover-danger"-->
<!--                      >-->
<!--                        <i class=" fa-solid fa-x fa-2xl"></i>-->
<!--                      </span>-->
<!--                    </span>-->
<!--                </a>-->
<!--              </div>-->
            </ng-container>
          </ng-container>

        </ng-container>
      </div>
      <!-- enter area -->
      <ng-template #loadingTemplate>
        <div class="text-gray-800 fw-semibold fs-4 flex-row">
          <ngx-shimmer-loading  [width]="'30%'" [height]="'20px'">
          </ngx-shimmer-loading>  <ngx-shimmer-loading  [width]="'30%'" [height]="'20px'">
        </ngx-shimmer-loading> <ngx-shimmer-loading  [width]="'30%'" [height]="'20px'">
        </ngx-shimmer-loading> <ngx-shimmer-loading  [width]="'30%'" [height]="'20px'">
        </ngx-shimmer-loading> <ngx-shimmer-loading  [width]="'30%'" [height]="'20px'">
        </ngx-shimmer-loading>
        </div>
      </ng-template>
    </div>
  </div>
</div>
<ng-template #nodata>
  <tr>
    <td colspan="5">
      <div
        class="notice d-flex bg-light-primary rounded border-primary border border-dashed mb-9 p-6"
      >
        <!--begin::Icon-->
        <i class="ki-duotone ki-design-1 fs-2tx text-primary me-4"></i>
        <!--end::Icon-->

        <!--begin::Wrapper-->
        <div class="d-flex flex-stack flex-grow-1">
          <!--begin::Content-->
          <div class="fw-semibold">
            <div class="fs-6 text-gray-700" >
              {{'widgets.no_data' | translate}}
            </div>
          </div>
          <!--end::Content-->
        </div>
        <!--end::Wrapper-->
      </div>
    </td>
  </tr>
</ng-template>
